// import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import WorkImageMain from '../../assets/img/workImageMain.jpeg'
import WorkImage1 from '../../assets/img/workImg1.webp'
import WorkImage3 from '../../assets/img/workImg3.webp'
import WorkImage4 from '../../assets/img/workImg4.webp'
import WorkImage6 from '../../assets/img/workImg6.webp'
import WorkImage7 from '../../assets/img/workImg7.webp'
import WorkImage8 from '../../assets/img/workImg8.webp'
import WorkImage9 from '../../assets/img/workImg9.webp'
import WorkImage10 from '../../assets/img/workImg10.webp'
import WorkImage11 from '../../assets/img/workImg11.webp'
import WorkImage12 from '../../assets/img/workImg12.webp'
import WorkImage13 from '../../assets/img/workImg13.webp'
import WorkImage14 from '../../assets/img/workImg14.jpeg'
import WorkImage15 from '../../assets/img/workImg15.jpeg'
import WorkImage16 from '../../assets/img/workImg16.webp'
import WorkImage17 from '../../assets/img/workImg17.webp'
import WorkImage18 from '../../assets/img/workImg18.webp'
import WorkImage19 from '../../assets/img/workImg19.webp'
import WorkImage20 from '../../assets/img/workImg20.webp'
import WorkImage21 from '../../assets/img/workImg21.webp'
import WorkImage22 from '../../assets/img/workImg22.webp'
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import './style.css';

// import required modules
import { Pagination } from 'swiper/modules';
import { Image } from '@chakra-ui/react';

export default function CustomSwiper() {
  return (
    <>
      <Swiper
        spaceBetween={30}
        pagination={{
          clickable: true,
          
        }}
        modules={[Pagination]}
        breakpoints={{
         
          642:{
            slidesPerView:2
          },
          1000:{
            slidesPerView:3
          },
        }}
        className="mySwiper"
      >
        <SwiperSlide >
          <Image src={WorkImageMain} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
        <Image src={WorkImage18} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage9} loading='lazy' />
        </SwiperSlide>
      
        <SwiperSlide>
          <Image src={WorkImage1} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
        <Image src={WorkImage21} loading='lazy' />

        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage22} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage17} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
        <Image src={WorkImage14} loading='lazy' />

        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage13} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage3} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage4} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage6} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage7} loading='lazy' />
        </SwiperSlide>    
         <SwiperSlide>
          <Image src={WorkImage15} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage10} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage11} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage12} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage16} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage8} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage19} loading='lazy' />
        </SwiperSlide>
        <SwiperSlide>
          <Image src={WorkImage20} loading='lazy' />
        </SwiperSlide>
      </Swiper>
    </>
  );
}

